module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cvi.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/pra.htm",
      "id": "pra"
    }
  }, [_vm._v("Praise for Val McDermid’s Lindsay Gordon series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/also.htm",
      "id": "also"
    }
  }, [_vm._v("Also by Val McDermid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/int.htm",
      "id": "int"
    }
  }, [_vm._v("Introduction to the Grove Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1tp.htm",
      "id": "p1-tp"
    }
  }, [_vm._v("Final Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1ack.htm",
      "id": "p1-ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1pro.htm",
      "id": "p1-pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c01.htm",
      "id": "p1-c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c02.htm",
      "id": "p1-c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c03.htm",
      "id": "p1-c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c04.htm",
      "id": "p1-c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c05.htm",
      "id": "p1-c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c06.htm",
      "id": "p1-c06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c07.htm",
      "id": "p1-c07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c08.htm",
      "id": "p1-c08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c09.htm",
      "id": "p1-c09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c10.htm",
      "id": "p1-c10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c11.htm",
      "id": "p1-c11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c12.htm",
      "id": "p1-c12"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c13.htm",
      "id": "p1-c13"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c14.htm",
      "id": "p1-c14"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c15.htm",
      "id": "p1-c15"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c16.htm",
      "id": "p1-c16"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c17.htm",
      "id": "p1-c17"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c18.htm",
      "id": "p1-c18"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c19.htm",
      "id": "p1-c19"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c20.htm",
      "id": "p1-c20"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1c21.htm",
      "id": "p1-c21"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p1epi.htm",
      "id": "p1-epi"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2tp.htm",
      "id": "p2-tp"
    }
  }, [_vm._v("Union Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2note.htm",
      "id": "p2-note"
    }
  }, [_vm._v("Note to Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2ded.htm"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2pro.htm",
      "id": "p2-pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2p1.htm",
      "id": "p2-p1"
    }
  }, [_vm._v("Part I: Blackpool, April 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2c01.htm",
      "id": "p2-c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2c02.htm",
      "id": "p2-c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2c03.htm",
      "id": "p2-c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p2c04.htm",
      "id": "p2-c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3p2.htm",
      "id": "p3-p2"
    }
  }, [_vm._v("Part II: Sheffield, April 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c01.htm",
      "id": "p3-c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c02.htm",
      "id": "p3-c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c03.htm",
      "id": "p3-c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c04.htm",
      "id": "p3-c04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c05.htm",
      "id": "p3-c05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c06.htm",
      "id": "p3-c06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c07.htm",
      "id": "p3-c07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c08.htm",
      "id": "p3-c08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c09.htm",
      "id": "p3-c09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c10.htm",
      "id": "p3-c10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c11.htm",
      "id": "p3-c11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c12.htm",
      "id": "p3-c12"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c13.htm",
      "id": "p3-c13"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c14.htm",
      "id": "p3-c14"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c15.htm",
      "id": "p3-c15"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c16.htm",
      "id": "p3-c16"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3c17.htm",
      "id": "p3-c17"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p3epi.htm",
      "id": "p3-epi"
    }
  }, [_vm._v("Epilogue")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/back.htm"
    }
  }, [_vm._v("Back Cover")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349bca82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 75
// module chunks = 0